// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__5A3W-","actionsCol":"EnrolledClinics_actionsCol__5rLS2"};